import { render, staticRenderFns } from "./EmbedSquareIcon.vue?vue&type=template&id=70ab0fec&scoped=true"
import script from "./EmbedSquareIcon.vue?vue&type=script&lang=js"
export * from "./EmbedSquareIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ab0fec",
  null
  
)

export default component.exports